<template>
  <el-container>
    <el-aside width="70px">
      <navbar :id-config-cliente-app="idConfigClienteApp"/>
    </el-aside>
    <el-container>
      <el-header height="auto">
        <navbar-dashboard />
      </el-header>
      <el-container class="el-main-dashboard">
        <router-view />
      </el-container>
      <el-footer width="auto" height="auto">
        <omni-footer/>
      </el-footer>
    </el-container>
    <ChatbotHelp />
  </el-container>
</template>
<script>
import Navbar from '@/components/shared/navbar/navbar-configuracoes/Navbar.vue'
import OmniFooter from '@/components/shared/footer/OmniFooter.vue'
import NavbarDashboard from '@/components/shared/navbar/navbar-dashboard/NavbarDashboard.vue'
import ChatbotHelp from '@/components/ChatbotHelp.vue'
import { mapMutations } from 'vuex'
import api from '@/api/configuradorPublicoApi'

export default {
  name: 'PainelConfiguracoes',
  metaInfo: {
    title: 'Configurações gerais'
  },
  computed: {
    idConfigClienteApp () {
      return this.$route.params.idConfigClienteApp
    }
  },
  components: {
    ChatbotHelp,
    NavbarDashboard,
    Navbar,
    OmniFooter
  },
  methods: {
    ...mapMutations('SelecionaAplicacao', ['SET_APLICACOES']),
    async init () {
      this.loading = true

      if (this.aplicacoes && this.aplicacoes.length > 0) {
        this.loading = false
        return
      }

      await this.listaAplicacoes()
      this.loading = false
    },
    async listaAplicacoes () {
      try {
        const result = await api.listaAplicacoes()

        if (result.status === 200 && result.data && result.data.status) {
          let aplicacoes = result.data.data
          const promises = aplicacoes.map(async (item) => {
            let esquemaDeCor = await this.__handlerEsquemaDeCores(item.id_cliente_app)
            let iconData = this.iconApp(esquemaDeCor)
            return {
              ...item,
              possuiIcon: iconData.possuiIcon,
              icon: iconData.icon,
              esquema_de_cores: esquemaDeCor
            }
          })

          const aplication = await Promise.all(promises)
          await this.SET_APLICACOES(aplication)

          if (result.data.data.length > 0) {
            await this.onChange(result.data.data[0].id_cliente_app)
          } else {
            this.error = true
          }
        } else {
          this.error = true
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
        this.error = true
      }
      this.loading = false
    },
    async __loadVersoesAtivas (idConfigClienteApp) {
      return api.carregaVersoesAtivas({ idConfigClienteApp })
        .then(result => {
          if (result.status === 200 && result.data && result.data.status) {
            return result.data.data
          }
        })
    },
    async __loadEsquemaDeCor (idConfigClienteApp, idVersao) {
      const esquemasCores = await api.listarEsquemaDeCores({ idConfigClienteApp, idVersao })
      if (Object.keys(esquemasCores.data.data).length === 0) {
        return {}
      }
      let esquemaCor = esquemasCores.data.data.find(item => item.default === 1)
      let idEsquemaDeCores = esquemaCor.id_config_app_esquema_cor

      return api.carregarEsquemaDeCores({ idConfigClienteApp, idVersao, idEsquemaDeCores })
        .then(result => {
          if (result.status === 200 && result.data && result.data.status) {
            return result.data.data
          }
        })
    },
    async __handlerEsquemaDeCores (idConfigClienteApp) {
      const versoesAtivas = await this.__loadVersoesAtivas(idConfigClienteApp)
      let versao = versoesAtivas.producao || versoesAtivas.sandbox
      let idVersao = (versao || {}).id_config_cliente_app_versao
      return this.__loadEsquemaDeCor(idConfigClienteApp, idVersao)
    },
    iconApp (esquemaDeCor) {
      let payload = {
        icon: require('@/assets/img/avatar-empresa-default.png'),
        possuiIcon: false
      }
      if (Object.keys(esquemaDeCor).length === 0) {
        return payload
      }
      let estilosImagensWeb = esquemaDeCor.estilos.find(item => item.nome_grupo === 'imagensWeb')
      if (!estilosImagensWeb) {
        return payload
      }
      let icon = estilosImagensWeb.estilos.find(item => item.chave === 'favIconWeb')
      if (!icon) {
        return payload
      }
      return {
        icon: icon.valor_atribuido,
        possuiIcon: true
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.el-container {
  box-shadow: 0 -1px 0 #0000001a;
}
.el-aside {
  border-right: 1px solid #dddddd;
  overflow: hidden;
}
.el-header {
  border-bottom: 1px solid #dddddd;
}
.el-main-dashboard {
  background-color: #f6f6f6;
  padding: 0;
}
</style>
